import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import LegendCircleRow from './CircleRow';
import LegendFillRow from './FillRow';
import LegendLineRow from './LineRow';
import LegendImg from './Img';
import LegendRaster from './Raster';

import { IComposite } from '../../../redux/layers/layerTypes';

type CompositeProps = {
  style: IComposite;
};

function Composite({ style }: CompositeProps) {
  const classes = useStyles();

  function getSubStyle(subStyle: any, key: number) {
    switch (subStyle.type) {
      case 'fill':
        return <LegendFillRow style={subStyle} />;
      case 'circle':
        return <LegendCircleRow style={subStyle} />;
      case 'line':
        return <LegendLineRow style={subStyle} />;
      case 'img':
        return <LegendImg style={subStyle} />;
      case 'raster':
        return <LegendRaster style={subStyle} />;
      default:
        console.log('Unidentified type', style.subStyle);
    }
  }

  return (
    <div className={classes.row}>
      {style.styles.map((s, idx) => (
        <div key={idx} className={classes.container}>
          {getSubStyle(s, idx)}
        </div>
      ))}
      <div className={classes.nameColumn}>
        <Typography variant="caption" className="name">
          {style.label}
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      display: 'grid',
      gridTemplateColumns: '55px auto',
      alignItems: 'center',
      height: '30px'
    },
    container: {
      position: 'absolute'
    },
    nameColumn: {
      color: theme.palette.background.contrastText,
      display: 'flex',
      alignItems: 'center'
    },
    line: {
      height: 0,
      width: '30px',
      margin: '0 auto'
    }
  })
);

export default Composite;
